import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from 'firebase/firestore';
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCs4-9sb73N0utOg2J755iqsaQGq5OGV1s",
  authDomain: "next-salon.firebaseapp.com",
  projectId: "next-salon",
  storageBucket: "next-salon.firebasestorage.app",
  messagingSenderId: "1038385547103",
  appId: "1:1038385547103:web:ca2b2931d1a004905518ea",
  measurementId: "G-2Y7DLHN527"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const db = getFirestore(app);
export const storage = getStorage(app);